import { compose, get, getOr, countBy, compact, values, over, reject } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { DateTimeService } from '@mews/framework';
import { DENSE_LIGHT_THEME } from '@optimus-web/theme';
import { getToken } from '@optimus-web/core';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getNowUtc } from '@mews-commander/utils';
import { getCurrentEnterpriseTasks } from '@mews-commander/legacy-entities/src/ducks/tasks';
import {
    getCurrentEnterpriseAppDateTimeNow,
    getEndOfTodayUtc,
} from '@mews-commander/legacy-entities/src/selectors/session/dateTime';
import { moduleSelector } from '../module';

export const tasksStatistics = compose(get('tasksStatistics'), moduleSelector);
export const isLoaded = compose(get('isLoaded'), tasksStatistics);
export const getLastModified = compose(getOr(0, 'lastModified'), tasksStatistics);

export const getTasksStatisticsChartData = createSelector(
    getCurrentEnterpriseTasks,
    getContainer,
    getEndOfTodayUtc,
    (data, container, endOfTodayUtc) => {
        const { appLocalizationComponent } = container();
        const nowUtc = getNowUtc();
        const countTasks = compose(
            over([
                countBy(({ deadlineUtc }) => deadlineUtc >= nowUtc && deadlineUtc < endOfTodayUtc),
                countBy(({ deadlineUtc }) => deadlineUtc < nowUtc),
            ]),
            reject('closedUtc'),
            values
        );
        const [{ true: pendingTasksCount }, { true: missedTasksCount }] = countTasks(data);
        return compact([
            pendingTasksCount > 0 && {
                value: pendingTasksCount,
                color: getToken('legacyTagBorderDenim')({ theme: DENSE_LIGHT_THEME }),
                label: appLocalizationComponent.localizeText(TextKey.Pending),
            },
            missedTasksCount > 0 && {
                value: missedTasksCount,
                color: getToken('legacyTagBorderTangerine')({ theme: DENSE_LIGHT_THEME }),
                label: appLocalizationComponent.localizeText(TextKey.Missed),
            },
        ]);
    }
);

export const getPreviousMonthUtc = createSelector(getCurrentEnterpriseAppDateTimeNow, (now) => {
    const today = DateTimeService.startOfDay(now);

    const previousMonth = DateTimeService.addMonths(today, -1);
    return DateTimeService.toUtc(previousMonth).value;
});
